import React, { createContext, useContext } from 'react';
import { useTargetListEdit } from '../../hooks';

const TargetListEditContext = createContext();

export const TargetListEditProvider = ({ children }) => {
  const {
    targetList,
    setTargetList,
    listName,
  } = useTargetListEdit();

  return (
    <TargetListEditContext.Provider
      value={{
        targetList,
        setTargetList,
        listName,
      }}
    >
      {children}
    </TargetListEditContext.Provider>
  );
};

export const useTargetListEditContext = () => useContext(TargetListEditContext);
